import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CaseStudy = ({
  title,
  company,
  image,
  link,
  locked,
  className,
  story,
  comingSoon,
  comingSoonLabel
}) => {
  let _redirLink;

  if (comingSoon) {
    _redirLink = '';
  } else if (locked) {
    _redirLink = `/password-gate?redirect=${link}`;
  } else {
    _redirLink = link;
  }

  const cardClassName = `case-study ${className}${comingSoon ? ' case-study--coming-soon' : ''}`;

  const body = (
    <div className="case-study__content">
      <header className="case-study__header">
        <h3 className="case-study__company">{company}</h3>
        <h2 className="case-study__title">{title}</h2>
      </header>
      <div className="case-study__body">{story}</div>
      {locked && !comingSoon && (
        <div className="case-study__lock-note">
          <FontAwesomeIcon icon="lock" />
          <span>Locked</span>
        </div>
      )}
    </div>
  );

  const content = comingSoon ? (
    <div className="case-study__coming-soon-inner">
      <div className="case-study__coming-soon-main">
        <div className="case-study__image">
          <img src={image} alt={`${title} Screenshot`} />
        </div>
        {body}
      </div>
      <span className="case-study__tag">{comingSoonLabel}</span>
    </div>
  ) : (
    <>
      <span className="case-study__arrow" aria-hidden>
        <FontAwesomeIcon icon="arrow-right" />
      </span>
      <div className="case-study__image">
        <img src={image} alt={`${title} Screenshot`} />
      </div>
      {body}
    </>
  );

  if (comingSoon) {
    return <article className={cardClassName}>{content}</article>;
  }

  return (
    <NavLink className={cardClassName} to={_redirLink}>
      {content}
    </NavLink>
  );
};

CaseStudy.propTypes = {
  title: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string,
  locked: PropTypes.bool,
  className: PropTypes.string.isRequired,
  story: PropTypes.string.isRequired,
  comingSoon: PropTypes.bool,
  comingSoonLabel: PropTypes.string
};

CaseStudy.defaultProps = {
  link: '',
  locked: false,
  comingSoon: false,
  comingSoonLabel: 'Coming soon'
};

export default CaseStudy;
